import { type CardProps as MuiCardProps } from '@mui/material';

import { BlurredCard, BlurType, StyledCard } from './blurred-card';

interface CardProps extends MuiCardProps {
  blur?: BlurType;
}

export const Card = ({ blur, variant = 'outlined', ...rest }: CardProps) => {
  if (blur) {
    return <BlurredCard blur={blur} {...rest} />;
  }
  return <StyledCard variant={variant} {...rest} />;
};
